"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _default = exports.default = {
  common: {
    shipRepair: '修船管理',
    query: '查询',
    reset: '重置',
    title: '标题',
    add: '新增',
    export: '导出',
    exports: '批量导出',
    save: '保存',
    updates: '批量更新',
    fileSearch: '文件搜索',
    saveAndAdd: '保存并新增',
    submit: '提交',
    cancel: '取消',
    goBack: '返回',
    operation: '操作',
    edit: '编辑',
    detail: '详情',
    moduleEdit: '模块出题维护',
    test: '进入考试',
    startTest: '开始考试',
    delete: '删除',
    suggestStart: '发起'
  },
  selectMessage: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
    addQuestions: '请先添加试题',
    feedbackDate: '反馈日期',
    addCompany: '请添加适用公司后再提交',
    read: '已阅',
    associatedQuestionBank: '关联大题库',
    requiredFlag: '大题库必考试题',
    singleMaintenanceQuestions: '单文件试题维护',
    maintenanceQuestions: '维护试题',
    answer: '正确答案',
    task: '任务指派与监控',
    feedback: '落实反馈',
    start: '进入考试',
    examination: '学习完考试',
    needExam: '是否考试',
    failedTopic: '获取题目失败',
    submitFailure: '提交失败',
    submitSuccessfully: '提交成功',
    repeatNumber: '标准编号重复！',
    deleteMsgTip: '此版本包含未删除的文件/表格，不能删除！',
    mustBeFilled: "船端岗位与岸端岗位必填一个",
    oneCorrectAnswer: "最少设置一个正确答案",
    eachMustFilled: "每个选项都必须填写内容",
    questionsUnanswered: '试卷有题未答，仍要提交吗',
    confirmSubmission: '确认提交吗',
    canceled: '已取消',
    common: '共',
    questions: '题',
    alreadyAnswered: '已答',
    unanswered: '未答',
    hour: "时",
    haveNotStarted: '未开始',
    underway: '进行中',
    completed: '已完成',
    minutes: "分",
    seconds: "秒",
    totalNum: '总数量',
    learnedNum: '已学习数量',
    feedbackNum: '已反馈数量',
    questionModule: '出题模块',
    shipName: '考试船舶',
    examAdress: '考试地点',
    onShip: '在船',
    onVacation: '在家休假',
    onOffice: '办公室',
    moduleInvolved: '涉及模块',
    examType: '考试类型',
    questionType: '试题类型',
    judge: '判断题',
    company: '所属公司',
    version: '版本',
    status: '状态',
    draft: '草稿',
    effectiveDate: '生效日期',
    inApproval: '审批中',
    approvalCompleted: '审批完成',
    effective: '有效',
    invalid: '无效',
    notInForce: '未生效',
    selectMsg: '岸端岗位与船端岗位必选一个',
    selectMsg1: '船端学习岗位不能为空',
    updateFile: '更新文件',
    edit: '编辑',
    delete: '删除',
    add: '新增',
    look: '查看',
    download: '下载',
    getFail: '获取失败',
    updates: '批量更新',
    message: '请选择',
    questionMsg: '获取失败，请稍后再试！',
    deleteMsg: '确认要删除该记录？',
    cancelMsg: '确认要作废该记录？',
    updateStatus: '确认要修改选中状态？',
    isExam: '考试状态',
    examDate: '考试日期',
    tips: '提示',
    confirm: '确定',
    cancel: '取消',
    deleteSuccess: '操作成功',
    deleteFail: '操作失败',
    cancelDelete: '取消操作',
    StandardManagement: '标准管理',
    saveSuccess: '保存成功',
    saveFail: '保存失败',
    selectDate: '选择日期',
    uploadFail: '上传失败，请重新上传！',
    startDate: '生效开始日期',
    endDate: '生效结束日期',
    operation: '操作',
    fileType: '文件类型',
    ApplicablePosition: '岗位',
    shipPosition: '船端岗位',
    questionTitle: '题干',
    questionTitleMsg: '请输入题干',
    relationChapter: '涉及章节',
    relationChapterMsg: '请输入涉及章节',
    publicMsg: '请输入',
    yes: '是',
    no: '否',
    OptionsAndAnswerSettings: '选项及答案设置',
    option: '选项',
    AnswerSetting: '答案设置',
    OptionContent: '选项内容',
    moduleEdit: '模块出题维护',
    examPost: '岸端考试岗位',
    test: '进入考试',
    startTest: '开始考试',
    examNo: '任务编号',
    taskName: '任务名称',
    userName: '姓名',
    JobNumber: '工号',
    taskNo: '任务编号',
    tempsave: '暂存草稿',
    Assignor: '指派人',
    AssignDate: '指派日期',
    CompletionDate: '要求完成日期',
    FeedbackResults: '是否需要反馈',
    FeedbackResult: '反馈落实结果',
    taskRequirements: '任务要求',
    LearningRequirements: '学习要求',
    FeedbackContent: '反馈内容',
    FeedbackTime: '要求落实完成日期',
    Enclosure: '补充附件',
    EnclosurePDF: '补充附件(PDF)',
    Enclosures: '反馈附件',
    UploadFile: '上传附件',
    FinishReading: '阅毕',
    Close: '关闭',
    saveDetail: '操作成功'
  }, "saveFail", '操作失败'), "feedbackAssignRemark", '落实要求'), "feedbackRelustRemark", '落实结果'), "tooltips", '必填项未填写完整'), "learnUserName", '反馈人'), "learnUserJob", '反馈人岗位'), "learnUserDepartment", '反馈人部门'),
  examQuestion: {
    index: {
      title: '体系考试',
      item: '考试题库',
      query: {
        itemName: '项目名称'
      },
      table: {
        department: '部门',
        tableNo: '',
        sysPostId: '适用岗位',
        examMouduleId: '涉及模块',
        relationFileChapter: '涉及章节',
        questionType: '试题类型',
        questionTitle: '题干',
        numberOfModuleQuestions: '模块出题数量',
        number: '数量'
      },
      filterList: {
        status: '试题状态',
        effective: '有效',
        invalid: '无效'
      }
    },
    editQuestion: {
      form: {
        title: '考试题库',
        questionType: '试题类型',
        sysPostId: '适用岗位',
        examMouduleId: '涉及模块',
        relationFileChapter: '涉及章节',
        examType: '考试类型',
        requiredFlag: '必考试题',
        effectFlag: '是否生效',
        questionProbablity: '试题权重',
        temporaryFlag: '临时性试题',
        questionTitle: '题干',
        comfirmMsg: '确认'
      }
    }
  },
  examAssign: {
    index: {
      exam: '考试',
      title: '体系考试',
      item: '考试指派',
      query: {
        itemName: '项目名称'
      },
      table: {
        examTaskNo: '任务编号',
        examTaskName: '任务名称',
        questionType: '考试类型',
        sysPostId: '考试岗位',
        principalOrgCode: '考试船舶',
        startTime: '开始日期',
        endTime: '截止日期',
        testSummer: '考试情况',
        testStatus: '考试状态',
        sponsor: '发起人'
      }
    },
    editAssign: {
      form: {
        title: '增加考试任务',
        examTaskNo: '任务编号',
        questionType: '考试类型',
        examTaskNameCn: '任务名称',
        startTime: '考试开始日期',
        endTime: '考试截止日期',
        examPostId: '岸端考试岗位',
        sysPostId: '船端岗位',
        shorePostId: '岸端岗位',
        principalOrgCode: '考试船舶',
        examTaskRemark: '考试要求'
      }
    }
  },
  examTest: {
    index: {
      title: '体系考试',
      item: '在线考试',
      query: {
        itemName: '项目名称'
      },
      table: {
        examTaskNo: '任务编号',
        examTaskNameCn: '任务名称',
        sysUserNameCn: '姓名',
        sysUserNo: '工号',
        sysPostId: '岗位',
        lastTestTime: '考试日期',
        testCore: '考试成绩',
        locationNameCn: '考试地点',
        testStatus: '考试状态',
        shipName: '船舶',
        marksPercent: '百分率',
        average: '平均分'
      }
    },
    testPaper: {
      form: {
        title: '试卷信息',
        userName: '姓名',
        userNo: '工号',
        startTime: '考试日期',
        reviewScore: '考试成绩',
        single: '单选题',
        multiple: '多选题',
        judgment: '判断题',
        standardAnswer: '标准答案',
        userAnswer: '你的答案',
        testStatus: '考试状态',
        paper: '试卷',
        remainTime: '剩余时间'
      }
    },
    editExamTest: {
      form: {
        title: '考试题库',
        examTaskNo: '任务编号',
        examTaskNameCn: '任务名称',
        sysUserNameCn: '姓名',
        sysUserNo: '工号',
        sysPostId: '岗位',
        sysRole: '角色',
        lastTestTime: '考试日期',
        testCore: '考试成绩',
        locationNameCn: '考试地点',
        testStatus: '考试状态',
        questionType: '考试类型'
      }
    }
  },
  examSummary: {
    index: {
      title: '体系考试',
      item: '考试统计',
      query: {
        itemName: '考试查询'
      },
      table: {
        userName: '姓名',
        userNo: '工号',
        sysUserNameCn: '岗位',
        principalOrgCode: '船舶',
        questionType: '考试类型',
        startTime: '考试日期',
        locationName: '考试地点',
        longtime: '考试时长',
        testCore: '考试成绩',
        testStatus: '任务编号',
        examTaskNo: '任务名称'
      }
    }
  }
};